import React from "react"
import P from "prop-types"
import styles from "./OpportunityParamsItem.module.scss"
import { Grid } from "@material-ui/core"
import Typography from "@material-ui/core/Typography"
import classNames from "classnames"
import {
  convertCamelCaseToTitle,
  dhm,
  renderReadableText,
} from "../../../../../helpers/textHelpers"
import { formatDisplayDate } from "../../../../../helpers/dateHandlers"
import { getIconByName } from "../../../heplers"
import CopyToClipboard from "../../../../CopyToClipboard"
import TimeAgo from "javascript-time-ago"
import en from "javascript-time-ago/locale/en"

TimeAgo.addDefaultLocale(en)
const timeAgo = new TimeAgo("en-US")

const LINKIFIED_FIELDS = new Set([
  "how_to_apply",
  "company_culture",
  "advisory_board_protocol",
  "sponsorship_protocol",
  "board_of_directors_protocol",
])

const isPlaceholderSourceWebsite = (value) =>
  /^see source website$/i.test(String(value || "").trim())

const OpportunityParamsItem = ({ title, value }) => {
  // Sync may store "See source website" for mandatory empty fields.
  // Hide the whole row; do not display the placeholder.
  if (!title || !value || isPlaceholderSourceWebsite(value)) return null

  let displayValue = value
  let valueClassName = styles.infoSectionValue

  if (title === "posted") {
    const delta = Math.abs(new Date() - new Date(value))
    displayValue =
      dhm(delta).days > 7
        ? formatDisplayDate(value)
        : timeAgo.format(new Date(value))
  } else if (title === "opportunity_expiration") {
    displayValue = formatDisplayDate(value) || value
  } else if (title === "contact") {
    displayValue = <CopyToClipboard text={value} />
  } else if (LINKIFIED_FIELDS.has(title)) {
    displayValue = (
      <span className={styles.linkedValue}>{renderReadableText(value)}</span>
    )
    valueClassName = classNames(
      styles.infoSectionValue,
      styles.infoSectionValueWide,
    )
  }

  return (
    <Grid
      component="div"
      className={classNames(styles.infoSectionItem)}
      container
    >
      <Grid
        component="div"
        xl={4}
        xs={6}
        lg={4}
        md={4}
        sm={6}
        item
        className={styles.infoSectionItemTitle}
      >
        <span className={styles.infoSectionIcon}>{getIconByName(title)}</span>
        <Typography
          className={styles.infoSectionTitle}
          component="h5"
          variant="h5"
        >
          {convertCamelCaseToTitle(title)}:
        </Typography>
      </Grid>
      <Grid
        component="div"
        className={styles.infoSectionItem}
        xl={8}
        xs={6}
        lg={8}
        md={8}
        sm={6}
        item
      >
        <h5 className={classNames(valueClassName)}>{displayValue}</h5>
      </Grid>
    </Grid>
  )
}

OpportunityParamsItem.propTypes = {
  title: P.string,
  value: P.string,
}

OpportunityParamsItem.defaultProps = {
  title: "",
  value: "",
}

export default OpportunityParamsItem
